import React, { FunctionComponent, useCallback, useState } from 'react';
import { FaRegFolder } from 'react-icons/fa6';
import { IMeetingFoldersProps } from './types';
import { useSelectWithParams } from '../../../../../utils/selector.utils';
import { meetingSimpleSelectors } from '../../../../../app/resource/meeting-simple/meeting-simple.selectors';
import { useDispatch } from 'react-redux';
import { openDialog } from '../../../../../app/dialog/dialog.actions';
import {
  deleteMeetingFolder,
  updateMeetingFolder,
} from '../../../../../app/page/page-storage/meeting-folder/meeting-folder.actions';
import { MeetingList } from '../MeetingMenuItems/MeetingList';
import { FaFolder, FaRegFolderOpen, FaCheck } from 'react-icons/fa6';
import { IconContext } from 'react-icons';
import { sortBy } from 'lodash';

export const MeetingFolder: FunctionComponent<IMeetingFoldersProps> = ({
  folder,
  selected,
  setSelectedFolder,
  isSidebarCollapsed,
}) => {
  const dispatch = useDispatch();
  const meetingsIds = folder.meetingIds;
  let meetings = useSelectWithParams(meetingSimpleSelectors.selectResourcesById, meetingsIds);
  meetings = sortBy(meetings, 'title');

  const [open, setOpen] = useState<boolean>(folder.open);
  const [editableFolderId, setEditableFolderId] = useState<string | null>(null);
  const [isEdit, setIsEdit] = useState<boolean | null>(false);
  const [newName, setNewName] = useState<string>('');

  const toggleOpen = () => {
    dispatch(updateMeetingFolder({ id: folder.id, open: !open }));
    setOpen(!open);
  };

  const handleEditClick = (folderId: string) => {
    setIsEdit(!isEdit);
    setNewName(folder.name);
    setEditableFolderId(folderId === editableFolderId ? null : folderId);
  };

  const handleEditConfirm = (folderId: string) => {
    setIsEdit(!isEdit);
    setEditableFolderId(folderId === editableFolderId ? null : folderId);
    if (newName && newName?.length > 0 && !!isEdit && newName !== folder.name) {
      dispatch(updateMeetingFolder({ id: folderId, name: newName }));
      setNewName('');
    }
  };

  const openDeleteConfirmationModel = useCallback(
    (folderId) => {
      dispatch(
        openDialog('confirmation', {
          title: 'Delete meeting folder',
          message:
            'Deleting a meeting date is permanent and there is no way to get it back. Do you want to continue anyway?',
          onConfirm: () => {
            dispatch(deleteMeetingFolder(folderId));
          },
        }),
      );
    },
    [dispatch],
  );

  if (!isSidebarCollapsed) {
    return (
      <>
        <div className="folder-title">
          <div onClick={() => !isEdit && toggleOpen()} style={{ display: 'flex', alignItems: 'center' }}>
            <div className="folder-icon">{open ? <FaRegFolderOpen /> : <FaRegFolder />}</div>
            {editableFolderId && editableFolderId === folder.id ? (
              <div
                style={{
                  border: `${newName?.length === 0 ? '1px solid red' : 'none'}`,
                  borderRadius: '8px',
                }}
              >
                <input
                  type="text"
                  value={newName}
                  onChange={(e) => setNewName(e.target.value)}
                  style={{
                    width: '100%',
                    height: 'auto',
                  }}
                />
              </div>
            ) : (
              <span className="folder-name">{folder.name}</span>
            )}
          </div>
          {editableFolderId && editableFolderId === folder.id ? (
            <div className="flex align-center">
              <IconContext.Provider value={{ color: 'white' }}>
                <FaCheck onClick={() => handleEditConfirm(folder.id)} style={{ marginLeft: 4 }} />
              </IconContext.Provider>
            </div>
          ) : (
            <div className="action-buttons">
              <i
                className="icon icon-pencil white ml-1"
                onClick={() => !isEdit && handleEditClick(folder.id)}
                style={{ cursor: `${!isEdit ? 'pointer' : 'default'}` }}
              />
              <i
                className="icon2-trash white ml-1"
                onClick={() => openDeleteConfirmationModel(folder.id)}
                style={{ cursor: `${!isEdit ? 'pointer' : 'default'}` }}
              />
            </div>
          )}
        </div>

        {open && <MeetingList meetings={meetings} droppableId={folder.id} isSidebarCollapsed={isSidebarCollapsed} />}
      </>
    );
  } else {
    if (selected) {
      if (selected === folder.id) {
        return <MeetingList meetings={meetings} droppableId={folder.id} isSidebarCollapsed={isSidebarCollapsed} />;
      } else {
        return null;
      }
    } else {
      return (
        <a onClick={() => setSelectedFolder(folder.id)}>
          <IconContext.Provider value={{ color: 'white' }}>
            <FaFolder size="23" width="25" />
          </IconContext.Provider>
          <span className="folder-initial">{folder.name.charAt(0)}</span>
          <span className="folder-name">{folder.name}</span>
        </a>
      );
    }
  }
};
